export const getDisplayValue = (loanTableData: Record<string, string | number>, key: string) =>
  loanTableData?.[key] ?? '';
